import { render, staticRenderFns } from "./reciteWord.vue?vue&type=template&id=806f2a40&scoped=true&"
import script from "./reciteWord.vue?vue&type=script&lang=js&"
export * from "./reciteWord.vue?vue&type=script&lang=js&"
import style0 from "./reciteWord.vue?vue&type=style&index=0&id=806f2a40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806f2a40",
  null
  
)

export default component.exports